'use client'

import { Bot, ArrowRight } from 'lucide-react'

export default function ToolCTA() {
  return (
    <div data-blog-layout='narrow' className='my-8'>
      <a
        href='/tools/ai-crawl-checker'
        data-cta-id='blog_tool'
        className='block !no-underline !decoration-transparent group'
      >
        <div
          className='relative overflow-hidden rounded-2xl p-8 md:p-10 transition-transform duration-200 hover:scale-[1.01]'
          style={{
            background: 'linear-gradient(135deg, #008dcc, #8b5cf6, #F90B8A)',
          }}
        >
          <div className='flex items-center gap-8'>
            <div className='flex-1 min-w-0'>
              <span className='inline-block text-[11px] font-bold tracking-[1.5px] uppercase text-white/80 mb-3'>
                Free Tool
              </span>
              <h3 className='text-xl md:text-2xl font-extrabold text-white leading-tight mt-0 mb-3'>
                Can AI Bots Find Your Content?
              </h3>
              <p className='text-sm md:text-[15px] text-white/85 leading-relaxed mb-5 mt-0'>
                Test how GPTBot, Claude, Perplexity, and 11 other bots see your
                website. Checks robots.txt, structured data, llms.txt, and
                content accessibility.
              </p>
              <span className='inline-flex items-center gap-2 bg-white text-[#008dcc] px-5 py-2.5 rounded-lg font-semibold text-sm group-hover:bg-white/95 transition-colors'>
                Try the AI Crawl Checker
                <ArrowRight size={16} />
              </span>
            </div>
            <div className='hidden md:flex items-center justify-center w-28 h-28 bg-white/15 rounded-2xl flex-shrink-0'>
              <Bot size={48} className='text-white/90' />
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}
